import Language from './models/Language';

export const AppStore = {
  language: Language.he
} 

export const setNewAnswer = (answer) => {
  
  localStorage.setItem(
    "answers",
    JSON.stringify({
      ...getAllAnswer(),
      ...answer,
    })
  );
};

export const getAllAnswer = () => {
  try {
    return JSON.parse(localStorage.getItem("answers"));
  } catch (e) {
    return "{}";
  }
};

export const clearAllAnswer = () => {
  console.log("clearAllAnswer");
  return localStorage.removeItem("answers");
};

export const calculateResult = () => {
  console.log("calculateResult");
  const allAnswer = getAllAnswer();
  let sum = 0;

  if (!allAnswer[2]) {
    sum += 10;
  }

  if (!!allAnswer[3]) {
    switch (allAnswer[1]) {
      case 1: {
        sum += 17.5;
        break;
      }
      case 2: {
        sum += 37.5;
        break;
      }
      case 3: {
        sum += 75;
        break;
      }
  
    }
  }
 
  switch (allAnswer[4]) {
    case 1: {
      sum += 1.25;
      break;
    }
    case 2: {
      sum += 2.5;
      break;
    }
    case 3: {
      sum += 6.25;
      break;
    }

  }

  switch (allAnswer[5]) {
    case 1: {
      sum += 6;
      break;
    }
    case 2: {
      sum += 12;
      break;
    }
    case 3: {
      sum += 18;
      break;
    }
    case 4: {
      sum += 24;
      break;
    }
  }

  switch (allAnswer[8]) {
    case 1: {
      sum += 14.583;
      break;
    }
    case 2: {
      sum += 29.167;
      break;
    }
    case 3: {
      sum += 87.5;
      break;
    }
  }

  switch (allAnswer[9]) {
    case 1: {
      sum += 2.0833;
      break;
    }
    case 2: {
      sum += 10.417;
      break;
    }
    case 3: {
      sum += 41.667;
      break;
    }
  }
  
  if (!!allAnswer[11]) {
    sum += 41.667;
  }
  
  return Math.round(sum);
};